import { HttpRequest, HttpMethod } from "./http";

// WMS product page — copies wms_products from Backoffice MariaDB into App PG
// and lets staff set storefront stock manually (Part B, issue #73).
class AppCatalogWmsProductProvider extends HttpRequest {
    // List copied wms_products from App PG joined with mdfpf_wms_stock.available.
    listPg(params) {
        return this.request(HttpMethod.Get, "/api/v1/bo/catalog/wms-products/pg", params);
    }

    // Search BO MariaDB wms_products (used by the import picker).
    //
    // Params are passed through untouched so BOTH forms of the endpoint keep
    // working: the paged `{q, page, page_size}` the import modal sends and the
    // older `{q, limit}` the bundle picker sends (that one has its own resource,
    // app_catalog_promotion_bundle.js, and must not be migrated here).
    search(params) {
        return this.request(HttpMethod.Get, "/api/v1/bo/catalog/wms-products", params);
    }

    // Same endpoint, paged. Separate name only so call sites read as what they
    // mean: `list` returns a page of the whole warehouse, `search` a match set.
    list(params) {
        return this.request(HttpMethod.Get, "/api/v1/bo/catalog/wms-products", params);
    }

    // Import selected wms_product ids from MariaDB into App PG (idempotent upsert).
    importProducts(payload) {
        return this.request(HttpMethod.Post, "/api/v1/bo/catalog/wms-products/import", payload);
    }

    // Set mdfpf_wms_stock.available for a wms_product (manual storefront stock).
    setStock(wmsId, payload) {
        return this.request(HttpMethod.Put, `/api/v1/bo/catalog/wms-products/${wmsId}/stock`, payload);
    }

    // Sync wms_products from Backoffice MariaDB into App PG (bulk upsert).
    sync() {
        return this.request(HttpMethod.Post, "/api/v1/bo/catalog/wms-products/sync");
    }
}

export default AppCatalogWmsProductProvider;
